// extracted by mini-css-extract-plugin
export var accent = "_8i-4";
export var add = "_8i-j";
export var addIcon = "_8i-k";
export var deleteIcon = "_8i-i";
export var disabled = "_8i-9";
export var ellipsis = "_8i-f";
export var error = "_8i-3";
export var form = "_8i-5";
export var hideFocus = "_8i-2";
export var icon = "_8i-7";
export var input = "_8i-e";
export var listItem = "_8i-h";
export var mediumHeight = "_8i-b";
export var noBorder = "_8i-8";
export var noRadius = "_8i-1";
export var shortHeight = "_8i-a";
export var tallHeight = "_8i-c";
export var textInput = "_8i-0";
export var vertical = "_8i-g";
export var veryTallHeight = "_8i-d";
export var widget = "_8i-6";